import { Button } from '@/components/ui/button';
import { UserPlus, UserCheck } from 'lucide-react';
import { useAuthorFollows } from '@/hooks/useAuthorFollows';
import { useAuth } from '@/hooks/useAuth';
import { toast } from 'sonner';

interface FollowAuthorButtonProps {
  authorName: string;
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  showText?: boolean;
}

export function FollowAuthorButton({ 
  authorName, 
  variant = 'outline', 
  size = 'default',
  showText = true 
}: FollowAuthorButtonProps) {
  const { user } = useAuth();
  const { isFollowing, followAuthor, unfollowAuthor, isFollowingLoading, isUnfollowingLoading } = useAuthorFollows();
  
  const following = isFollowing(authorName);
  const loading = isFollowingLoading || isUnfollowingLoading;

  const handleClick = () => {
    if (!user) {
      toast.error('Please sign in to follow authors');
      return;
    }

    if (following) {
      unfollowAuthor(authorName);
    } else {
      followAuthor(authorName);
    }
  };

  return (
    <Button
      variant={following ? 'default' : variant}
      size={size}
      onClick={handleClick}
      disabled={loading}
    >
      {following ? (
        <>
          <UserCheck className="h-4 w-4" />
          {showText && <span className="ml-2">Following</span>}
        </>
      ) : (
        <>
          <UserPlus className="h-4 w-4" />
          {showText && <span className="ml-2">Follow</span>}
        </>
      )}
    </Button>
  );
}
